import React from 'react';
import styles from '../assets/styles/ServiceInVictoria.module.css';
import imgVictoria from '../assets/images/victoria.png';

const ServiceInVictoria = ({ header, content }) => {
  return (
    <div>
      <div className={styles.serviceInVictoria}>
        <div className={styles.headerRow}>
          <div className={styles.imgContainer}>
            <img src={imgVictoria} className={styles.img} alt='Victoria'/>
          </div>
          <div className={styles.header}>{header}</div>
        </div>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  );
};

export default ServiceInVictoria;